/* eslint-disable react/prop-types, camelcase */
import React from 'react';
import { graphql } from 'react-relay';
import { withRouter } from 'react-router-dom';

import Breadcrumbs from '~/modules/coreUI/components/basic/Breadcrumbs';
import BreadcrumbsLinks from '~/modules/ecommerceCore/BreadcrumbsLinks';

import withRootQuery from '~/modules/core/utils/relayHelpers/withRootQuery';

// Home >TRACK_NAME > DEPARTMENT_NAME > SHOP_NAME

const ShopDetailsBreadcrumbs = ({ queryResult: { shop } }) => (
  <Breadcrumbs
    crumbs={[
      BreadcrumbsLinks.HOME(),
      BreadcrumbsLinks.SHOPS_TRACK(shop.vendor_track?.track_type, shop.vendor_track.name),
      BreadcrumbsLinks.SHOPS_DEPARTEMENT(shop.departments[0].ref_id, shop.departments[0].name, shop.vendor_track.track_type),
      BreadcrumbsLinks.SHOP(shop.ref_id, shop.name),
    ]}
  />
);

const ShopDetailsBreadcrumbsQuery = graphql`
  query ShopDetailsBreadcrumbsQuery($id: ID!) {
    shop(id: $id) {
      ref_id
      name
      slug
      vendor_track {
        ref_id
        name
        track_type
      }
      departments {
        ref_id
        name
        enabled
        icon
        position
      }
    }
  }
`;

export default withRouter(withRootQuery(
  ShopDetailsBreadcrumbs,
  ShopDetailsBreadcrumbsQuery,
  null,
  props => ({
    id: parseInt(props.match.params.vendorID, 10),
  }),
));
